import { useQuery } from "@tanstack/react-query";

export interface Invoice {
  id: number;
  invoiceNumber: string;
  clientId: number;
  clientName: string;
  clientTier: 'basic' | 'professional' | 'enterprise';
  amount: number;
  currency: string;
  status: 'paid' | 'pending' | 'overdue' | 'cancelled';
  type: string;
  description?: string;
  createdAt: string;
  dueDate: string;
}

export interface InvoiceFilters {
  status?: 'paid' | 'pending' | 'overdue' | 'all';
  dateFrom?: string;
  dateTo?: string;
  clientTier?: 'basic' | 'professional' | 'enterprise' | 'all';
}

export function useInvoices(filters?: InvoiceFilters) {
  const queryParams = new URLSearchParams();
  
  if (filters?.status && filters.status !== 'all') {
    queryParams.append('status', filters.status);
  }
  if (filters?.dateFrom) {
    queryParams.append('dateFrom', filters.dateFrom);
  }
  if (filters?.dateTo) {
    queryParams.append('dateTo', filters.dateTo);
  }
  if (filters?.clientTier && filters.clientTier !== 'all') {
    queryParams.append('clientTier', filters.clientTier);
  }
  
  const queryString = queryParams.toString();
  const queryKey = queryString ? `/api/invoices?${queryString}` : '/api/invoices';

  return useQuery<Invoice[]>({
    queryKey: [queryKey],
    enabled: true,
  });
}

export function useInvoicesExport(filters?: InvoiceFilters) {
  const exportInvoices = async () => {
    const queryParams = new URLSearchParams();
    
    if (filters?.status && filters.status !== 'all') {
      queryParams.append('status', filters.status);
    }
    if (filters?.dateFrom) {
      queryParams.append('dateFrom', filters.dateFrom);
    }
    if (filters?.dateTo) {
      queryParams.append('dateTo', filters.dateTo);
    }
    if (filters?.clientTier && filters.clientTier !== 'all') {
      queryParams.append('clientTier', filters.clientTier);
    }
    
    queryParams.append('format', 'csv');
    
    const response = await fetch(`/api/invoices?${queryParams.toString()}`);
    if (!response.ok) throw new Error('Export failed');
    
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `invoices_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };
  
  return { exportInvoices };
}